import { IndicatorProps, TextProps } from 'spindl-shared-components';

type TableTabItemInternalProps = {
  text?: TextProps;
  indicator?: IndicatorProps;
};

type TableTabItemPropsValues = {
  'Selected': TableTabItemInternalProps;
  'Unselected': TableTabItemInternalProps;
};

const propValues: TableTabItemPropsValues = {
  'Selected': {
    text: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Interactive',
      type: 'Heading5',
    },
    indicator: {
      state: 'Selected',
      type: 'Horizontal',
      error: 'None',
    },
  },
  'Unselected': {
    text: {
      align: 'Center',
      styleType: 'SemiBold',
      colour: 'Subdued',
      type: 'Heading5',
    },
    indicator: {
      state: 'Unselected',
      type: 'Horizontal',
      error: 'None',
    },
  },
};

const getProps = (type: string): TableTabItemInternalProps => {
  const values: TableTabItemInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
